export default __webpack_public_path__ + "static/media/guide_02.4c43a758.md";